export default "__VITE_ASSET__37b1ec11__"